import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import type { PropType } from 'vue'
  import type { CompanyWidget } from '@/services/interfaces/Auth0'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomWidgetsWrapper',
  props: {
    widget: {
      type: Object as PropType<CompanyWidget>,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const widgetTarget = computed(() => (props.widget.type === 'link' ? '_blank' : 'self'))

return { __sfc: true,props, widgetTarget, computed }
}

})